import axios from "axios";
import { Help, ServerAddress } from "../Enum/Urls";

export const getTickets = async (parameters) => {

    if (!parameters.token) {
        return
    }

    try {

        const paramsArray = [];

        paramsArray.push(`MaxResultCount=${parameters.MaxResultCount || 10}`);
        paramsArray.push(`SkipCount=${parameters.SkipCount || 0}`);

        if (parameters.Statuses) {
            paramsArray.push(`Statuses=${parameters.Statuses}`);
        }
        if (parameters.CreationTimeFrom) {
            paramsArray.push(`CreationTimeFrom=${parameters.CreationTimeFrom}`);
        }
        if (parameters.CreationTimeTo) {
            paramsArray.push(`CreationTimeTo=${parameters.CreationTimeTo}`);
        }
        if (parameters.ReserveId) {
            paramsArray.push(`ReserveId=${parameters.ReserveId}`);
        }

        if (parameters.notRead) {
            paramsArray.push("IsRead=false");
        }

        let response = await axios.get(
            `${ServerAddress.Type}${ServerAddress.Help}${Help.GetAll}?${paramsArray.join("&")}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    "tenantid": process.env.REACT_APP_SERVER_TENANTID,
                    Authorization: `Bearer ${parameters.token}`
                },
            },
        )
        return response
    } catch (error) {
        return error
    }
}

export const getTicketDetail = async (parameters, acceptLanguage = "fa-IR") => {

    if (!parameters.token) {
        return
    }

    try {
        let response = await axios.get(
            `${ServerAddress.Type}${ServerAddress.Help}${Help.Get}?id=${parameters.id}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    "tenantid": process.env.REACT_APP_SERVER_TENANTID,
                    Authorization: `Bearer ${parameters.token}`,
                    'Accept-Language': `${acceptLanguage}`,
                },
            },
        )
        return response
    } catch (error) {
        return error
    }
}

export const getTitles = async (token, acceptLanguage = 'fa-IR') => {
    
    if (!token) {
        return
    }
    try {

        let response = await axios.get(
            `${ServerAddress.Type}${ServerAddress.Help}${Help.GetAllTitles}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    "tenantid": process.env.REACT_APP_SERVER_TENANTID,
                    'Accept-Language': `${acceptLanguage}`,
                    Authorization: `Bearer ${token}`
                },
            },
        )
        return response
    } catch (error) {
        return error
    }
}

export const createNewTicket = async (param, token, acceptLanguage = 'fa-IR') => {

    if (!token) {
        return
    }

    try {
        let response = await axios.post(`${ServerAddress.Type}${ServerAddress.Help}${Help.Create}`,
            param,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': `${acceptLanguage}`,
                    "tenantid": process.env.REACT_APP_SERVER_TENANTID,
                    Authorization: `Bearer ${token}`
                },
            },
        )
        return response
    } catch (error) {
        return error.response?.data
    }
}

export const TicketAddMessage = async (param, token, acceptLanguage = 'fa-IR') => {

    if (!token) {
        return
    }

    try {
        let response = await axios.post(`${ServerAddress.Type}${ServerAddress.Help}${Help.AddMessage}`,
            param,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': `${acceptLanguage}`,
                    "tenantid": process.env.REACT_APP_SERVER_TENANTID,
                    Authorization: `Bearer ${token}`
                },
            },
        )
        return response
    } catch (error) {
        return error.response?.data
    }
}


export const TicketAddAttachment = async (param, token, acceptLanguage = 'fa-IR') => {

    if (!token) {
        return
    }

    try {
        let response = await axios.post(`${ServerAddress.Type}${ServerAddress.Help}${Help.AddAttachment}`,
            param,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': `${acceptLanguage}`,
                    "tenantid": process.env.REACT_APP_SERVER_TENANTID,
                    Authorization: `Bearer ${token}`
                },
            },
        )
        return response
    } catch (error) {
        return error.response?.data
    }
}